import "./style.css";

export default class CookieBanner {
  static selector = ".cookie-banner";

  constructor(block) {
    this.block = block;

    const cookiePolicy = window.localStorage.getItem("cookiePolicy");
    if (cookiePolicy) {
      this.hideCookieBanner();
    } else {
      this.okLink = block.querySelector(".link");
      this.okLink.addEventListener("click", this.onOkClicked);
    }
  }

  hideCookieBanner = () => {
    this.block.style.display = "none";
  };

  onOkClicked = () => {
    this.block.addEventListener("transitionend", this.onTransitionEnded);
    this.block.style.opacity = "0";
    window.localStorage.setItem("cookiePolicy", '1');
  };

  onTransitionEnded = () => {
    this.block.removeEventListener("transitionend", this.onTransitionEnded);
    this.hideCookieBanner();
  }
}
